import { isBlank } from '@/utils/validate'
import request from '@/utils/request'
export default {
  data() {
    return {
      deleteList: [],
      mitmdtlpModelList: [],
      hopeList: [],
    }
  },
  computed: {
    requestDestCd() {
      return this.$store.getters['user/requestDestCd']
    },
    requestDestName() {
      return this.$store.getters['user/requestDestName']
    },
    empnmkj() {
      return this.$store.getters['user/empnmkj']
    },
    filename() {
      return this.$store.getters['user/filename']
    },
    showDownLoad() {
      let demandType = this.getFieldValue('demandType', this.info)
      let requestClass = this.getFieldValue(
        'requestIdModel.requestClass',
        this.info
      )
      if (
        (this.isEqualCodeEnum(
          demandType,
          this.$divisions.demandTypeEnum.enum_1
        ) ||
          this.isEqualCodeEnum(
            demandType,
            this.$divisions.demandTypeEnum.enum_6
          )) &&
        this.isEqualCodeEnum(
          requestClass,
          this.$divisions.requestClassEnum.enum_1
        )
      ) {
        return true
      } else if (
        this.isEqualCodeEnum(
          demandType,
          this.$divisions.demandTypeEnum.enum_2
        ) &&
        this.isEqualCodeEnum(
          requestClass,
          this.$divisions.requestClassEnum.enum_1
        )
      ) {
        return true
      } else if (
        this.isEqualCodeEnum(
          demandType,
          this.$divisions.demandTypeEnum.enum_3
        ) &&
        (this.isEqualCodeEnum(
          requestClass,
          this.$divisions.requestClassEnum.enum_1
        ) ||
          this.isEqualCodeEnum(
            requestClass,
            this.$divisions.requestClassEnum.enum_2
          ))
      ) {
        return true
      }
      return false
    },
    vaildateTimeStart() {
      return (row, index) => {
        if (this.form.scheduleAdjDetailModelList.length > 0) {
          if (row && row.endDateTime && this.rules && !row.startDateTime) {
            this.$set(
              this.rules,
              `scheduleAdjDetailModelList.${index}.startDateTime`,
              [
                {
                  required: true,
                  message: this.format(
                    this.$t(
                      `validateMessage.${this.$messageCode.E00000001.name}`
                    ),
                    '日程'
                  ),
                  trigger: 'blur',
                },
              ]
            )
          }
          // else if (
          //   row &&
          //   row.endDateTime &&
          //   this.rules &&
          //   row.startDateTime
          // ) {
          //   this.$refs.form.clearValidate(['startDateTime', 'endDateTime'])
          // }
          else {
            this.$nextTick(() => {
              this.$refs.form.clearValidate([
                `scheduleAdjDetailModelList.${index}.startDateTime`,
              ])
              if (this.rules) {
                this.$set(
                  this.rules,
                  `scheduleAdjDetailModelList.${index}.startDateTime`,
                  [
                    {
                      required: false,
                      message: null,
                    },
                  ]
                )
              }
            })
          }
        }
      }
    },
    vaildateTimeEnd() {
      return (row, index) => {
        if (this.form.scheduleAdjDetailModelList.length > 0) {
          if (row && row.startDateTime && this.rules && !row.endDateTime) {
            this.$set(
              this.rules,
              `scheduleAdjDetailModelList.${index}.endDateTime`,
              [
                {
                  required: true,
                  message: this.format(
                    this.$t(
                      `validateMessage.${this.$messageCode.E00000001.name}`
                    ),
                    '日程'
                  ),
                  trigger: 'blur',
                },
              ]
            )
          }
          // else if (
          //   row &&
          //   row.endDateTime &&
          //   this.rules &&
          //   row.startDateTime
          // ) {
          //   this.$refs.form.clearValidate(['startDateTime', 'endDateTime'])
          // }
          else {
            this.$nextTick(() => {
              this.$refs.form.clearValidate([
                `scheduleAdjDetailModelList.${index}.endDateTime`,
              ])
              if (this.rules) {
                this.$set(
                  this.rules,
                  `scheduleAdjDetailModelList.${index}.endDateTime`,
                  [
                    {
                      required: false,
                      message: null,
                    },
                  ]
                )
              }
            })
          }
        }
      }
    },
    dealingFlgData() {
      return [
        this.$divisions.dealingFlgEnum.enum_0.value,
        this.$divisions.dealingFlgEnum.enum_2.value,
      ].includes(this.form?.dealingFlg)
    },
    disabledFileName() {
      return (row) => {
        return (
          this.isEqualCodeEnum(
            row?.docSubmitStatus,
            this.$divisions.docSubmitStatusEnum.enum_8
          ) ||
          this.isEqualCodeEnum(
            row?.reportSubmitStatus,
            this.$divisions.docSubmitStatusEnum.enum_8
          )
        )
      }
    },
    isSc3() {
      return this.isEqualCodeEnum(
        this.getFieldValue('demandType', this.info),
        this.$divisions.demandTypeEnum.enum_3
      )
    },
  },
  mounted() {},
  methods: {
    // 協力会社送信先
    getPartnerDestination(list) {
      if (!list) {
        return null
      }
      let workList = list.filter(
        (item) => item.notifyType == this.$divisions.notifyTypeEnum.work.value
      )
      if (workList.length > 0) {
        return JSON.stringify(workList)
      }
      return null
    },
    // DLN送信先
    getDlnDestination(list) {
      if (!list) {
        return null
      }
      let dlnList = list.filter(
        (item) => item.notifyType == this.$divisions.notifyTypeEnum.dln.value
      )
      if (dlnList.length > 0) {
        return JSON.stringify(dlnList)
      }
      return null
    },
    // 協力会社送信先
    getPartnerDestinationByRequestDestCd(requestDestCd, list) {
      if (!list) {
        return null
      }
      let workList = list.filter(
        (item) =>
          item.notifyType == this.$divisions.notifyTypeEnum.work.value &&
          item.requestDestCd == requestDestCd
      )
      if (workList.length > 0) {
        return JSON.stringify(workList)
      }
      return null
    },
    // *
    getRequiredFlg(docId) {
      let requiredFlg = null
      this.checkList.filter((item) => {
        if (item.docId == docId) {
          requiredFlg = item.requiredFlg
        }
      })
      return requiredFlg
    },
    // 書類提出/報告書一覧
    getFileList(bookList, pageData) {
      if (!bookList) return []
      let dataList = []
      let docIdList = bookList.map((map) => map?.docIdModel?.docId)
      docIdList = new Set(docIdList)
      docIdList.forEach((item) => {
        dataList.push({
          docId: item,
          docName: getDocName.call(this, item),
          list: [],
          requiredFlg: this.getRequiredFlg(item),
          uploadCheck: showUpload.call(this, item),
          ...getUploadUrl.call(this, null),
        })
      })
      dataList.filter((item) => {
        if (
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.document
          )
        ) {
          setListDocument.call(this, item)
        } else {
          setListReport.call(this, item)
        }
        item.list.filter((parent) => {
          bookList.filter((file) => {
            if (
              parent?.docIdModel.docId == file?.docIdModel.docId &&
              file.fileName
            ) {
              if (
                parent.company ==
                  this.$divisions.adjSourceClassEnum.enum_2.text &&
                [
                  this.$divisions.docConfirmFlgEnum.enum_2.value,
                  this.$divisions.docConfirmFlgEnum.enum_3.value,
                ].includes(file.docConfirmFlg)
              ) {
                file.delCheck = checkDel.call(this, parent)
                parent.fileList.push(file)
              } else {
                if (parent.docConfirmFlg == file.docConfirmFlg) {
                  file.delCheck = checkDel.call(this, parent)
                  parent.fileList.push(file)
                }
              }
            }
          })
          parent.dlnBtnList = getBtnList.call(this, parent)
          parent.showStateList = getShowStateList.call(this, parent, item)
        })
      })
      function getDocName(docId) {
        let book = bookList.find((item) => item.docIdModel.docId == docId)
        if (typeof book != 'undefined') {
          return book?.docIdModel.docName
        }
        return ''
      }
      function getCompanyName(row) {
        if (
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.document
          ) ||
          this.isEqualCodeEnum(
            row.docConfirmFlg,
            this.$divisions.docConfirmFlgEnum.enum_1
          )
        ) {
          return this.$divisions.adjSourceClassEnum.enum_1.text
        } else {
          if (
            this.isEqualCodeEnum(
              row.docConfirmFlg,
              this.$divisions.docConfirmFlgEnum.enum_2
            ) ||
            this.isEqualCodeEnum(
              row.docConfirmFlg,
              this.$divisions.docConfirmFlgEnum.enum_3
            )
          ) {
            return this.$divisions.adjSourceClassEnum.enum_2.text
          }
        }
      }
      // アップロードされたapi
      function getUploadUrl() {
        let data = {
          ...pageData,
        }
        // 報告書アップロード
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.report
          )
        ) {
          data.uploadUrl = '/api/scReport/upload'
          data.deleteUrl = '/api/scReport/delete'
          data.downLoadUrl = '/api/scReport/download'
          data.docConfirmFlg = this.$divisions.docConfirmFlgEnum.enum_1.value
        }
        // 書類提出
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.document
          )
        ) {
          data.uploadUrl = '/api/requestDocuments/upload'
          data.deleteUrl = '/api/requestDocuments/delete'
          data.downLoadUrl = '/api/requestDocuments/download'
        }
        return data
      }
      // 削除
      function checkDel(row) {
        // 協力会社 書類提出 可以删除
        let checkTmep = false
        let delList = [
          this.$divisions.docSubmitStatusEnum.enum_1.value,
          this.$divisions.docSubmitStatusEnum.enum_2.value,
          this.$divisions.docSubmitStatusEnum.enum_3.value,
          this.$divisions.docSubmitStatusEnum.enum_5.value,
        ]
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          ) &&
          delList.includes(row.docSubmitStatus ?? row.reportSubmitStatus)
        ) {
          checkTmep = true
        }
        // dln 書類确认
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.dln
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.document
          )
        ) {
          checkTmep = false
        }
        // dln 報告書 確認
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.dln
          ) &&
          delList.includes(row.reportSubmitStatus)
        ) {
          checkTmep = true
        }
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.dln
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.report
          ) &&
          this.isEqualCodeEnum(
            row.docConfirmFlg,
            this.$divisions.docConfirmFlgEnum.enum_1
          )
        ) {
          checkTmep = false
        }
        // 協力会社 報告書 dln  削除禁止
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          ) &&
          (this.isEqualCodeEnum(
            row.docConfirmFlg,
            this.$divisions.docConfirmFlgEnum.enum_2
          ) ||
            this.isEqualCodeEnum(
              row.docConfirmFlg,
              this.$divisions.docConfirmFlgEnum.enum_3
            ))
        ) {
          return false
        }
        return checkTmep
      }
      // アップロード
      function showUpload(docId) {
        let temp = true
        let filteList = bookList.filter(
          (item) => item?.docIdModel.docId == docId && item.fileName
        )
        let uploadList = [
          this.$divisions.docSubmitStatusEnum.enum_1.value,
          this.$divisions.docSubmitStatusEnum.enum_2.value,
          this.$divisions.docSubmitStatusEnum.enum_3.value,
          this.$divisions.docSubmitStatusEnum.enum_4.value,
          this.$divisions.docSubmitStatusEnum.enum_5.value,
        ]
        if (filteList.length == 0) {
          temp = true
        }
        // 協力会社 書類提出
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.document
          )
        ) {
          filteList.filter((row) => {
            if (
              !uploadList.includes(
                row.docSubmitStatus ?? row.reportSubmitStatus
              )
            ) {
              temp = false
            }
          })
        }
        // 協力会社 報告書
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.report
          )
        ) {
          filteList.filter((row) => {
            if (
              !uploadList.includes(
                row.docSubmitStatus ?? row.reportSubmitStatus
              )
            ) {
              temp = false
            }
          })
        }
        // dln 書類确认
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.dln
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.document
          )
        ) {
          temp = false
        }
        // dln 報告書
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.dln
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.report
          )
        ) {
          filteList.filter((row) => {
            if (
              !uploadList.includes(
                row.docSubmitStatus ?? row.reportSubmitStatus
              )
            ) {
              temp = false
            }
          })
        }
        return temp
      }
      // 差し戻し/確認
      function getBtnList(dataItem) {
        let btnList = [
          {
            docSubmitStatus: this.$divisions.docSubmitStatusEnum.enum_5.value,
            name: '差し戻し',
            check: false,
            checkClassName: 'backFileS',
            icon: 'back_2_line',
            type: 'button',
          },
          {
            docSubmitStatus: this.$divisions.docSubmitStatusEnum.enum_4.value,
            name: '確認',
            check: false,
            checkClassName: 'sureFileS',
            icon: 'check_line',
            type: 'button',
          },
        ]
        // dln 提出書類 確認
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.dln
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.document
          )
        ) {
          btnList.filter((item) => {
            if (
              item.docSubmitStatus ==
              (dataItem.docSubmitStatus ?? dataItem.reportSubmitStatus)
            ) {
              item.check = true
            }
          })
          return btnList
        }
        // dln 報告書 確認
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.dln
          ) &&
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.report
          )
        ) {
          if (
            this.isEqualCodeEnum(
              dataItem.docConfirmFlg,
              this.$divisions.docConfirmFlgEnum.enum_1
            )
          ) {
            return btnList.filter((item) => {
              if (
                item.docSubmitStatus == dataItem.docSubmitStatus ??
                dataItem.reportSubmitStatus
              ) {
                item.check = true
              }
            })
          }
          // "2":確認(連携不要) "3":確認(連携要)
          if (
            this.isEqualCodeEnum(
              dataItem.docConfirmFlg,
              this.$divisions.docConfirmFlgEnum.enum_2
            ) ||
            this.isEqualCodeEnum(
              dataItem.docConfirmFlg,
              this.$divisions.docConfirmFlgEnum.enum_3
            )
          ) {
            btnList = [
              {
                type: 'checkbox',
                name: 'ファイルを協力会社に連携',
                check: this.isEqualCodeEnum(
                  dataItem.docConfirmFlg,
                  this.$divisions.docConfirmFlgEnum.enum_3
                ),
              },
            ]
            return btnList
          }
        }
        return []
      }
      // 提出書類
      function setListDocument(item) {
        bookList.filter((row) => {
          if (
            row?.docIdModel.docId == item.docId &&
            item.list.length == 0 &&
            row.fileName
          ) {
            row.fileList = []
            row.company = getCompanyName.call(this, row)
            item.list.push(row)
          }
        })
      }
      // 報告書
      function setListReport(item) {
        bookList.filter((row) => {
          if (row?.docIdModel.docId == item.docId) {
            if (
              item.list.length == 0 &&
              this.isEqualCodeEnum(
                row.docConfirmFlg,
                this.$divisions.docConfirmFlgEnum.enum_1
              ) &&
              row.fileName
            ) {
              row.fileList = []
              row.company = getCompanyName.call(this, row)
              item.list.push(row)
            }
          }
        })
        let temp = false
        bookList.filter((row) => {
          if (row?.docIdModel.docId == item.docId) {
            if (
              !temp &&
              row.fileName &&
              (this.isEqualCodeEnum(
                row.docConfirmFlg,
                this.$divisions.docConfirmFlgEnum.enum_2
              ) ||
                this.isEqualCodeEnum(
                  row.docConfirmFlg,
                  this.$divisions.docConfirmFlgEnum.enum_3
                ))
            ) {
              row.fileList = []
              row.company = getCompanyName.call(this, row)
              let docConfirmFlgList = item.list.map((doc) => doc.docConfirmFlg)
              if (!docConfirmFlgList.includes(row.docConfirmFlg)) {
                item.list.push(row)
                temp = true
              }
            }
          }
        })
      }
      // 書類提出状況
      function getShowStateList(itemList, item) {
        // 協力会社 報告書 DLN 无状态
        if (
          this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.report
          ) &&
          (this.isEqualCodeEnum(
            itemList.docConfirmFlg,
            this.$divisions.docConfirmFlgEnum.enum_2
          ) ||
            this.isEqualCodeEnum(
              itemList.docConfirmFlg,
              this.$divisions.docConfirmFlgEnum.enum_3
            )) &&
          item?.list &&
          item?.list?.length == 2
        ) {
          return []
        }
        let blueList = [
          this.$divisions.docSubmitStatusEnum.enum_4.value,
          this.$divisions.docSubmitStatusEnum.enum_6.value,
          this.$divisions.docSubmitStatusEnum.enum_7.value,
        ]
        let redList = [
          this.$divisions.docSubmitStatusEnum.enum_5.value,
          this.$divisions.docSubmitStatusEnum.enum_8.value,
        ]
        let list = []

        // work 報告書 /提出書類
        if (
          this.isEqualCodeEnum(
            pageData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          ) &&
          (this.isEqualCodeEnum(
            pageData.fileType.value,
            this.$divisions.bookTypeEnum.report
          ) ||
            this.isEqualCodeEnum(
              pageData.fileType.value,
              this.$divisions.bookTypeEnum.document
            ))
        ) {
          let data = {
            docSubmitStatusName: '',
            state: '',
          }
          if (
            this.isEqualCodeEnum(
              pageData.fileType.value,
              this.$divisions.bookTypeEnum.report
            )
          ) {
            data.docSubmitStatusName = this.getEnumText(
              itemList.reportSubmitStatus,
              this.$divisions.docSubmitStatusEnum
            )
            data.state = itemList.reportSubmitStatus
          }

          if (
            this.isEqualCodeEnum(
              pageData.fileType.value,
              this.$divisions.bookTypeEnum.document
            )
          ) {
            data.docSubmitStatusName = this.getEnumText(
              itemList.docSubmitStatus,
              this.$divisions.docSubmitStatusEnum
            )
            data.state = itemList.docSubmitStatus
          }
          if (blueList.includes(data.state)) {
            data.color = '#0060C2'
            data.borderColor = '#B9DAFF'
            data.bg = '#ECF5FF'
            data.icon = 'check_line'
          } else if (redList.includes(data.state)) {
            data.color = '#C90022'
            data.borderColor = '#F19597'
            data.bg = '#FFF6F6'
            data.icon = 'back_2_line'
          } else {
            data.color = '#848484'
            data.borderColor = '#848484'
            data.bg = '#F7F7F7'
            data.icon = 'check_line'
          }
          list.push(data)
        }
        return list
      }
      return dataList
    },
    // アップロードしなければならないかチェックします
    checkBookRequired(pageData) {
      let list = this.checkList
      let temp = true
      let docName = ''
      list.filter((item) => {
        if (this.checkEnumFlag(item.requiredFlg) && temp) {
          let fileList = this.initList.filter(
            (file) =>
              file.fileName && file?.docIdModel?.docId == item.docIdModel?.docId
          )
          if (
            fileList.length == 0 &&
            this.isEqualCodeEnum(
              pageData.roleType.value,
              this.$divisions.notifyTypeEnum.work
            )
          ) {
            docName = item.docIdModel.docName
            temp = false
          }
        }
      })
      return {
        check: temp,
        docName: docName,
      }
    },
    // 書類コメント
    setBookMessage(msg) {
      if (!msg) return
      if (msg.indexOf('[') !== -1) {
        let commentList = JSON.parse(msg)
        if (commentList.length > 0) {
          this.$refs.vabMessage.setList(commentList)
        }
      }
    },
    // 書類コメント
    getBookMessage(msg) {
      let msgList = []
      let data = {
        // // 部課名称
        deptName: this.requestDestName,
        // adjScheduleStatusDatetime: this.$dayjs().format(
        //   this.$const.dateFormatYYYYMMDDHHMM
        // ),
        adjSourceClass: this.$divisions.adjSourceClassEnum.enum_1.value,
        confirmRemarks: msg,
        // 担当者名
        userName: this.empnmkj,
      }
      msgList.push(data)
      return JSON.stringify(msgList)
    },
    // 見積情報ダウンロード
    async downLoadInfomation(url) {
      // let data = {
      //   acceptOrderKey: this.getFieldValue('acceptOrderNo', this.info),
      //   buildingCd: this.getFieldValue(
      //     'demandBaseIdModel.buildingCd',
      //     this.info
      //   ),
      //   demandType: this.getFieldValue(
      //     'demandBaseIdModel.demandType',
      //     this.info
      //   ),
      //   requestDestCd: this.getFieldValue('requestDestCd', this.info),
      // }
      this.downloadCommon.zip(url, this.info)
    },
    // SC3」事前調査の場合、不可日を選択不可
    checkNoDay(row, value, key, noDayList) {
      let isSame = false
      noDayList.filter((item) => {
        if (!isSame && !item.available) {
          if (this.$dayjs(item.date).isSame(value, 'day')) {
            isSame = true
          }
        }
      })
      if (isSame) {
        row[key] = null
      }
      return isSame
    },
    checkCalendar(value, timePeriodList) {
      return timePeriodList.some((item) => {
        return (
          this.$dayjs(item.date).isSame(value, 'day') &&
          item.timePeriodList &&
          item.timePeriodList.length > 0
        )
      })
    },
    // 日程調整依頼詳細の依頼対応区分は、デフォルト値が「"1":日程調整要」
    // 日程調整依頼の調査要否「"1":要」の場合、日程調整依頼詳細の依頼対応区分には、「"0":日程調整不要」選択できません
    // 日程調整依頼の調査要否「"0":不要」の場合、日程調整依頼詳細の依頼対応区分には、「"1":日程調整要」選択できません、デフォルト値が「"0":日程調整不要」
    dealingFlgCheck(info, form, lx) {
      let investigationFlg = this.getFieldValue(
        'requestIdModel.investigationFlg',
        info
      )
      if (
        this.isEqualCodeEnum(
          investigationFlg,
          this.$divisions.investigationFlgEnum.enum_1
        )
      ) {
        setTimeout(() => {
          let labelList = [
            this.$divisions.dealingFlgEnum.enum_1.text,
            this.$divisions.dealingFlgEnum.enum_2.text,
          ]
          this.$refs.dealingFlgRef.labelList = labelList
          if (lx == 'add') {
            this.$refs.dealingFlgRef.setValue(
              this.$divisions.dealingFlgEnum.enum_1.value
            )
            form.dealingFlg = this.$divisions.dealingFlgEnum.enum_1.value
          }
        }, 0)
      }
      if (
        this.isEqualCodeEnum(
          investigationFlg,
          this.$divisions.investigationFlgEnum.enum_0
        )
      ) {
        setTimeout(() => {
          let labelList = [
            this.$divisions.dealingFlgEnum.enum_0.text,
            this.$divisions.dealingFlgEnum.enum_2.text,
          ]
          this.$refs.dealingFlgRef.labelList = labelList
          if (lx == 'add') {
            this.$refs.dealingFlgRef.setValue(
              this.$divisions.dealingFlgEnum.enum_0.value
            )
            form.dealingFlg = this.$divisions.dealingFlgEnum.enum_0.value
          }
        }, 0)
      }
    },
    // 日付入力を無効にする
    disableWattingList(val) {
      if (this.$baseLodash.isNull(val)) return
      if (!this.checkEnumFlag(val)) {
        this.form.scheduleAdjDetailModelList.filter((item) => {
          item.disabled = true
          item.checkDisabled = true
          item.timeDisabled = true
          item.startTime = null
          item.endTime = null
          item.startDateTime = null
          item.endDateTime = null
          item.dayFlag = this.$divisions.validFlgEnum.enum_0.value
          this.$set(item, 'timeDisabled', true)
        })
      } else {
        this.form.scheduleAdjDetailModelList.filter((row) => {
          row.timeDisabled = false
          if (
            !this.$baseLodash.isEmpty(row.startDateTime) &&
            !this.$baseLodash.isEmpty(row.endDateTime)
          ) {
            let isSame = this.$dayjs(row.startDateTime).isSame(
              row.endDateTime,
              'day'
            )
            if (!isSame) {
              row.disabled = true
              row.startTime = null
              row.endTime = null
              row.checkDisabled = true
            } else {
              row.disabled = false
              row.checkDisabled = false
              row.dayFlag = 0
            }
          }
          this.$set(row, 'timeDisabled', false)
        })
      }
    },
    // 候補スケジュール選択をクリアする
    clear(index) {
      let dealingFlg = this.form.dealingFlg
      if (!this.checkEnumFlag(dealingFlg)) {
        return
      }
      if (this.dealingDisable) return
      this.form.scheduleAdjDetailModelList.filter((row, i) => {
        if (i === index) {
          row.disabled = true
          row.startTime = null
          row.endTime = null
          row.checkDisabled = true
          row.startDateTime = null
          row.endDateTime = null
          row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
          if (row.scheduleAdjDetailId) {
            row.operationType = this.$divisions.operationTypeEnum.enum_D.value
          } else {
            row.operationType = null
          }
        }
      })
      this.setWattingList(this.form.scheduleAdjDetailModelList)
    },
    // 終日
    changeDayFlag(val, row) {
      if (this.checkEnumFlag(val)) {
        row.disabled = true
        row.startTime = null
        row.endTime = null
      } else {
        row.disabled = false
      }
    },
    setOperationTypeFileList(list) {
      list.filter((item) => {
        item.operationType = this.$divisions.operationTypeEnum.enum_U.value
      })
    },
    getRealFileList() {
      let fileList = this.$baseLodash.cloneDeep(this.initList)
      let list = fileList.filter((item) => item.fileName)
      list.filter((item) => {
        delete item['dlnBtnList']
        delete item['showStateList']
        delete item['fileList']
        delete item['delCheck']
      })
      return list
    },
    getFomateMonth(value) {
      if (this.$baseLodash.isEmpty(value) || !this.$dayjs(value).isValid())
        return
      return this.$dayjs(value).format('YYYY/MM')
    },
    getSecTitile(row, index) {
      if (
        this.isEqualCodeEnum(
          this.info.adjScheduleStatus,
          this.$divisions.adjScheduleStatusEnum.enum_4
        ) &&
        this.checkEnumFlag(row?.selectFlg)
      ) {
        return '確定日程'
      } else {
        return '候補日程' + index
      }
    },
    setGoodsInfoList(info) {
      if (!info) return
      this.mitmdtlpModelList =
        this.getFieldValue(
          'demandBaseIdModel.itemCdModel.mitmdtlpModelList',
          info
        ) ?? []
    },
    checkRepeatDate(row, index, list) {
      if (list.length > 0) {
        let tempList = list
          .filter((item, m) => m != index)
          .map((item) => {
            if (
              item.startDateTime &&
              item.endDateTime &&
              item.startDateTime !== 'Invalid Date' &&
              item.endDateTime !== 'Invalid Date'
            ) {
              if (
                this.$dayjs(row.startDateTime).isAfter(
                  item.endDateTime,
                  'day'
                ) ||
                this.$dayjs(item.startDateTime).isAfter(row.endDateTime, 'day')
              ) {
                return false
              } else {
                return true
              }
            }
          })
        let temp = tempList.some((item) => item == true)
        if (temp) {
          this.msgInfo(
            this.$t(`validateMessage.${this.$messageCode.W00000464.name}`)
          )
          row.endDateTime = null
          row.startDateTime = null
          this.setDrawTimeList(list)
        }
        return temp
      }
    },
    changeNoticeFlg(val) {
      if (!this.checkEnumFlag(val)) {
        this.form.localPostingFlg = null
        this.form.managePostingFlg = null
        this.form.postingFlag = null
      }
    },
    // 希望開始日・終了日
    changeHopeDateList(expectStartDate, expectEndDate) {
      console.log('expectEndDate', expectEndDate)
      console.log('expectStartDate', expectStartDate)
      if (
        !this.$baseLodash.isEmpty(expectStartDate) &&
        !this.$baseLodash.isEmpty(expectEndDate)
      ) {
        let s = this.$dayjs(expectStartDate).format(
          this.$const.dateFormatYYYYMMDD
        )
        let e = this.$dayjs(expectEndDate).format(
          this.$const.dateFormatYYYYMMDD
        )
        let data = {
          start: s,
          end: e,
          color: '#295A7F',
          bg: 'rgba(0, 96, 194, 0.2)',
          type: 'hope',
          title: '希望日',
        }
        return [{ ...data }]
      }
      return []
    },
    // 希望開始日・終了日
    hopeDateListFill(expectStartDate, expectEndDate) {
      if (
        !this.$baseLodash.isEmpty(expectStartDate) &&
        !this.$baseLodash.isEmpty(expectEndDate)
      ) {
        let s = this.$dayjs(expectStartDate).format(
          this.$const.dateFormatYYYYMMDD
        )
        let e = this.$dayjs(expectEndDate).format(
          this.$const.dateFormatYYYYMMDD
        )
        let data = {
          start: s,
          end: e,
          color: '#295A7F',
          bg: 'rgba(0, 96, 194, 0.2)',
          type: 'hope',
          title: '希望日',
        }
        let list = [{ ...data }]
        this.$refs.calendar
          .getTimes(
            this.$dayjs(expectStartDate).format(this.$const.dateFormatYYYYMMDD)
          )
          .then(() => {
            this.$refs.calendar.clearFillForm(list)
          })
      }
      return []
    },
    setTimeSSS(item) {
      let startTime = this.formatTimeDefault(
        item.startTime,
        this.$const.dateFormatHHMMSSSSS
      )

      let endTime = this.formatTimeDefault(
        item.endTime,
        this.$const.dateFormatHHMMSSSSS,
        true
      )
      if (this.$dayjs(item.startDateTime).isValid()) {
        item.startDateTime =
          this.$dayjs(item.startDateTime).format(
            this.$const.dateFormatYYYYMMDD
          ) +
          ' ' +
          startTime
      }
      if (this.$dayjs(item.endDateTime).isValid()) {
        item.endDateTime =
          this.$dayjs(item.endDateTime).format(this.$const.dateFormatYYYYMMDD) +
          ' ' +
          endTime
      }
    },
    getScheduleAdjDetailModelList(modeList) {
      if (modeList.length == 0) return []
      let changeFormList = this.$baseLodash.cloneDeep(modeList)
      changeFormList.forEach((item) => {
        this.setTimeSSS(item)
      })
      let list = this.compareArr({
        originArr: this.initTableList,
        targetArr: changeFormList,
        identifyKey: 'scheduleAdjDetailId',
        keys: [
          'startDateTime',
          'endDateTime',
          'selectFlg',
          'waterOffStartTime',
          'waterOffEndTime',
          'electricOffStartTime',
          'electricOffEndTime',
          'collectionStartTime',
          'collectionEndTime',
          'parkFlg',
          'dayFlag',
        ],
      })
      for (let index = 0; index < list.length; index++) {
        let item = list[index]
        if (
          (!item.startDateTime || !item.endDateTime) &&
          this.isEqualCodeEnum(
            item.operationType,
            this.$divisions.operationTypeEnum.enum_I
          )
        ) {
          list.splice(index, 1)
          index--
        }
      }
      return list
        .filter((item) => item.operationType)
        .map((row) => {
          this.setTimeSSS(row)
          return row
        })
    },
    setOtherBookName(other, item) {
      if (isBlank(other)) {
        return item.docName
      }
      let docIdList = [99, 199]
      if (docIdList.includes(item.docId)) {
        return item.docName + '（' + other + '）'
      }
      return item.docName
    },
    async checkDayReportRequest(row) {
      let dataTime = {}
      if (row.startDateTime) {
        dataTime.dateFrom = this.$dayjs(row.startDateTime).format(
          this.$const.dateFormatYYYYMMDD
        )
        if (!row.endDateTime) {
          dataTime.dateTo = dataTime.dateFrom
        }
      }
      if (row.endDateTime) {
        dataTime.dateTo = this.$dayjs(row.endDateTime).format(
          this.$const.dateFormatYYYYMMDD
        )
        if (!row.startDateTime) {
          dataTime.dateFrom = dataTime.dateTo
        }
      }
      // 不可日
      let dayRes = await request({
        url: '/api/works/unavailable/day/answer',
        method: 'post',
        data: {
          buildingCd: this.getFieldValue(
            'demandBaseIdModel.buildingCd',
            this.info
          ),
          ...dataTime,
        },
      })
      if (!dayRes) {
        let dayReport = await request({
          url: '/api/works/unavailable/day/answer/repeat',
          method: 'post',
          data: {
            buildingCd: this.getFieldValue(
              'demandBaseIdModel.buildingCd',
              this.info
            ),
            sectionCd: this.getFieldValue(
              'demandBaseIdModel.sectionCd',
              this.info
            ),
            requestDetailId: this.getFieldValue('requestDetailId', this.info),
            ...dataTime,
          },
        })
        if (dayReport) {
          this.msgInfo(
            this.$t(`validateMessage.${this.$messageCode.W00000217.name}`)
          )
        }
      } else {
        this.msgInfo(
          this.$t(`validateMessage.${this.$messageCode.W00000286.name}`)
        )
      }
    },
    async checkDayReportError(row, key, type = 'info') {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let dataTime = {}
        if (row.startDateTime) {
          dataTime.dateFrom = this.$dayjs(row.startDateTime).format(
            this.$const.dateFormatYYYYMMDD
          )
          if (!row.endDateTime) {
            dataTime.dateTo = dataTime.dateFrom
          }
        }
        if (row.endDateTime) {
          dataTime.dateTo = this.$dayjs(row.endDateTime).format(
            this.$const.dateFormatYYYYMMDD
          )
          if (!row.startDateTime) {
            dataTime.dateFrom = dataTime.dateTo
          }
        }
        let dayRes = await request({
          url: '/api/works/unavailable/day/answer',
          method: 'post',
          data: {
            buildingCd: this.getFieldValue(
              'demandBaseIdModel.buildingCd',
              this.info
            ),
            ...dataTime,
          },
        })
        if (dayRes) {
          if (type == 'info') {
            this.msgInfo(
              this.$t(`validateMessage.${this.$messageCode.W00000213.name}`)
            )
          } else {
            this.msgError(
              this.format(
                this.$t(`validateMessage.${this.$messageCode.W00000428.name}`)
              )
            )
            row[key] = null
          }
        }
        resolve(dayRes)
      })
    },
    getNeedConfirm(list) {
      if (list.length == 0 || this.enAdjScheduleStatus4) return false
      let timeList = [
        ...list.map((item) => item.startDateTime),
        ...list.map((item) => item.endDateTime),
      ]
      // 25日以降（工事日程)
      let checkDay = timeList.some(
        (item) => this.$dayjs(item).format('DD') >= 25
      )
      if (!checkDay) {
        let contractEndDate = this.getFieldValue(
          'demandBaseIdModel.contractEndDate',
          this.info
        )
        if (
          this.$baseLodash.isEmpty(contractEndDate) ||
          this.$baseLodash.isUndefined(contractEndDate)
        ) {
          return false
        }
        return timeList.some((value) =>
          this.$dayjs(value).isAfter(this.$dayjs(contractEndDate))
        )
      }
      return checkDay
    },
    //  依頼年月
    getRequestYearMonth(list) {
      // (現地/予備調査の場合):選定の日程調整詳細.開始日時の年月					最も早い日程調整詳細.開始日時の年月					日程調整依頼.希望開始日の年月					案件基本の契約（予定）開始日の年月				今月
      // (工事/作業日程の場合):最も早い日程調整詳細.開始日時の年月				日程調整依頼.希望開始日の年月				        案件基本の契約（予定）開始日の年月		今月

      if (!this.$baseLodash.isEmpty(list)) {
        let filterList = list.filter(
          (item) => !this.$baseLodash.isEmpty(item.startDateTime)
        )
        // 選定の日程調整詳細.開始日時の年月
        let selectList = filterList.filter((item) =>
          this.checkEnumFlag(item.selectFlg)
        )
        if (!this.$baseLodash.isEmpty(selectList)) {
          return this.$dayjs(selectList[0].startDateTime).format(
            this.$const.dateFormatYYYYMMDD
          )
        }
        // 最も早い日程調整詳細.開始日時の年月
        let yearMonthList = filterList.map((obj) =>
          this.$dayjs(obj.startDateTime)
        )
        if (!this.$baseLodash.isEmpty(yearMonthList)) {
          let minDate = this.$dayjs.min(yearMonthList)
          return this.$dayjs(minDate).format(this.$const.dateFormatYYYYMMDD)
        }
      }
      // 日程調整依頼.希望開始日の年月
      if (
        !this.$baseLodash.isEmpty(
          this.getFieldValue('requestIdModel.expectStartDate', this.info)
        )
      ) {
        return this.getFieldValue('requestIdModel.expectStartDate', this.info)
      }
      // 案件基本の契約（予定）開始日の年月
      return (
        this.getFieldValue('demandBaseIdModel.contractStartDate', this.info) ??
        this.$dayjs().format(this.$const.dateFormatYYYYMMDD)
      )
    },
    // 書類ファイルを削除 >= 90日
    disabledFileNameByDate(date) {
      const addDay = this.$dayjs(date).add(90, 'day').format('YYYY/MM/DD')
      const flag = this.$dayjs().isBefore(this.$dayjs(addDay))
      return flag
    },
  },
}
